module.exports = __webpack_public_path__ + "img/dingding.6a2e30bb.svg";